<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h3>Poll Results</h3>
      </v-col>
      <v-col cols="12" v-for="(result,i) in results.poll" :key="i" md="6">
        <v-card class="align-center text-start fill-height">
          <v-card-title>
            County: {{result.poll.county}}<br/>
            From: {{result.poll.created_at | filterHumanDate}}
          </v-card-title>

          <v-row class="ma-2" v-for="(question,k) in result.candidates" :key="k">
            <p class="font-weight-bold"> {{ question.question }}</p>
            <pie-chart :download="{background: '#fff'}" suffix="%" height="200px" width="100%" legend="left" :data="question.results" />
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {getRequest} from "@/api/apirepository";

export default {
  name: "Results",
  data() {
    return {
      results: []
    }
  },
  methods: {
    getPolls() {
      getRequest('getPollResults').then(({data}) => {
        this.results = data;
      }).catch(e => {
        console.log(e)
      })
    }
  },
  created() {
    this.getPolls()
  }
}
</script>

<style scoped>

</style>